import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const { getBeneficiaries } = endpoints;

const loadBeneficiaries = async (params: any) => {
  try {
    const response = await axios.get(getBeneficiaries, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const createBeneficiary = async (newBen: any) => {
  const data = newBen;

  try {
    const response = await axios.post(getBeneficiaries, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const deleteBeneficiary = async (id: string) => {
  try {
    const response = await axios.delete(`${getBeneficiaries}/${id}`);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const updateBeneficiary = async (id: string, data: any) => {
  try {
    const response = await axios.put(`${getBeneficiaries}/${id}`, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const beneficiariesServices = {
  loadBeneficiaries,
  createBeneficiary,
  deleteBeneficiary,
  updateBeneficiary,
};

export default beneficiariesServices;
